
import "./Statistica.css";
import React, { useState, useEffect } from "react";
import { getStatisticsData } from "../../../api";
import Header from "../../../Components/Header/Header";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import CloseIcon from '@mui/icons-material/Close';
import ActiveClientsChart from "./ActiveClientsChart";
import AddCancelChart from "./AddCancelChart";
import BusinessTypeChart from "./BusinessTypeChart";
import PackageChart from "./PackageChart";
import ReasonChart from "./ReasonChart";

function Statistics() {

    const [startDate, setStartDate] = useState<string | undefined>("");
    const [endDate, setEndDate] = useState<string | undefined>("");
    const [activeClients, setActiveClients] = useState<any>();
    const [addClients, setAddClients] = useState<any>();
    const [businessTypes, setBusinessTypes] = useState<any>();
    const [canselations, setCanselations] = useState<any>();
    const [packages, setPackages] = useState<any>();
    const [reasons, setReasons] = useState<any>();
    const [addClientsCount, setAddClientsCount] = useState<number>(0);
    const [cancelClientsCount, setCancelClientsCount] = useState<number>(0);
    const [showDate, setShowDate] = useState<Array<string>>([]);
    const [showResetBtn, setShowResetBtn] = useState<boolean>(false);

    function getDaysInMonth () {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const date = new Date(currentYear, currentMonth, 1, 12, 0, 0, 0);
        const days = [];
        while (date.getMonth() === currentMonth) {
            days.push(new Date(date).toISOString().slice(0, 10).replaceAll("-", "/"));
            date.setDate(date.getDate() + 1);
        }
        setShowDate(days);
    }

    const getData = async () => {
        try {
            const response = await getStatisticsData();
            if (response) {
                setActiveClients(response.data.activeClients);
                setAddClients(response.data.addedClients);
                setBusinessTypes(response.data.businessTypes);
                setCanselations(response.data.cancellations);
                setPackages(response.data.packages);
                setReasons(response.data.reasons);
            }
        }
        catch (err) {
            throw err;
        }
    }

    useEffect(() => {
        getData().then(r => r);
        getDaysInMonth();
    }, []);

    const resetData = () => {
        setStartDate("");
        setEndDate("");
        getDaysInMonth();
    }

    const addClientsValue = () => {
        if (addClients) {
            const addClientsData = new Array();
            for (let key in addClients) {
                let obj = {
                    count: addClients[key],
                    date: key
                }
                addClientsData.push(obj);
            }
            const allAddData = new Array();
            showDate.forEach((date: string) => {
                const findAddData = addClientsData.find((addData: any) => addData.date === date);
                let obj = {
                    addCount: findAddData ? findAddData.count : 0,
                    date: date
                }
                allAddData.push(obj);
            })
            setAddClientsCount(allAddData.reduce((acc, curr) => acc += curr.addCount, 0));
        }
    }

    const cancelClientsValue = () => {
        if (canselations) {
            const cancelClientsData = new Array();
            for (let key in canselations) {
                let obj = {
                    count: canselations[key],
                    date: key
                }
                cancelClientsData.push(obj);
            }
            const allCancelData = new Array();
            showDate.forEach((date: string) => {
                const findCancelData = cancelClientsData.find((cancelData: any) => cancelData.date === date);
                let obj = {
                    addCount: findCancelData ? findCancelData.count : 0,
                    date: date
                }
                allCancelData.push(obj);
            })
            setCancelClientsCount(allCancelData.reduce((acc, curr) => acc += curr.addCount, 0));
        }
    }

    useEffect(() => {
        if (showDate.length > 0) {
            addClientsValue();
            cancelClientsValue();
        }
    }, [showDate, addClients, canselations])

    useEffect(() => {
        if (startDate || endDate) setShowResetBtn(true);
        else setShowResetBtn(false);
    }, [startDate, endDate]);

    const filterChartsData = () => {
        if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            if (start < end) {
                const days = [];
                while (start <= end) {
                    days.push(new Date(start).toISOString().slice(0, 10).replaceAll("-", "/"));
                    start.setDate(start.getDate() + 1);
                }
                setShowDate(days);
            }
        }
    }

    return (
        <div className = "Statistics">
            <Header/>
            <div className = "credit-card-info-container">
                <div className = "statistic-page-container-header-box">
                    <div className = "createClient-header">
                        <span className="createClientLeftArrowBox">
                            <KeyboardArrowLeftIcon
                                style = {{
                                    color: "#004DE7"
                                }}
                                onClick = { () => window.history.back() }
                            />
                        </span>
                        <h2> Statistics </h2>
                    </div>
                    <div className = "statistic-page-header-date-box">
                        {
                            showResetBtn &&
                                <span
                                    className = "createClientLeftArrowBox"
                                    style = {{
                                        padding: "20px"
                                    }}
                                >
                                    <CloseIcon
                                        style = {{
                                            color: "#004DE7",
                                            fontSize: "28px"
                                        }}
                                        onClick = { resetData }
                                    />
                                </span>
                        }
                        <input
                            type = "date"
                            className = "statistic-page-date-input"
                            value = { startDate }
                            onChange = { e => setStartDate(e.target.value) }
                        />
                        <input
                            type = "date"
                            className = "statistic-page-date-input"
                            value = { endDate }
                            onChange = { e => setEndDate(e.target.value) }
                        />
                        <button
                            className = "statistic-page-filter-button"
                            onClick = { filterChartsData }
                            style = {{
                                cursor: startDate && endDate ? "pointer" : "no-drop",
                                color: startDate && endDate ? "white" : "rgba(255,255,255,0.5)"
                            }}
                        >
                            Filter
                        </button>
                    </div>
                </div>
                <div className = "statistic-page-content-box">
                    <div className = "statistic-page-content-small-box">
                        {
                            activeClients ? <span className="statistic-active">  { activeClients[activeClients.length - 1].count } </span>
                                : "0"
                        }
                        Active
                    </div>
                    <div className = "statistic-page-content-small-box">
                        <span className = "statistic-add">  { addClientsCount } </span>
                        Added
                    </div>
                    <div className = "statistic-page-content-small-box">
                        <span className = "statistic-cancel">  { cancelClientsCount } </span>
                        Canceled
                    </div>
                </div>
                <ActiveClientsChart
                    activeClients = { activeClients }
                    showDate = { showDate }
                />
                <AddCancelChart
                    addClients = { addClients }
                    canselations = { canselations }
                    showDate = { showDate }
                />
                <div className = "statistic-piecharts-box">
                    <BusinessTypeChart
                        businessTypes = { businessTypes }
                        showDate = { showDate }
                    />
                    <PackageChart
                        packages = { packages }
                        showDate = { showDate }
                    />
                    <ReasonChart
                        reasons = { reasons }
                        showDate = { showDate }
                    />
                </div>
            </div>
        </div>
    )
}

export default Statistics
